// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H6_i0WShUjYCHR {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  list-style-type: none;
  cursor: pointer;
}
.H6_i0WShUjYCHR li {
  list-style-type: none;
}
.lzrY4EYP5_SBYj {
  padding: 6px 12px;
  list-style-type: none;
}
.lzrY4EYP5_SBYj:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.lzrY4EYP5_SBYj:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
}
.R4JCamcPDlrWzL {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  display: grid;
  grid-auto-columns: 44px;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  min-height: 48px;
  cursor: pointer;
}
.R4JCamcPDlrWzL:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.R4JCamcPDlrWzL:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
}
.uGtyPvoqpvcvdA {
  grid-column-end: 1;
  margin: auto 0 auto auto;
}
.eQgJeMj8wdLrO7 {
  padding: 6px 12px;
}
.oxWwWrsQvWQ_eZ {
  color: var(--ds-text-selected, #0c66e4);
}
.oIwB6kV3H6azbz {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
.UiFE4JadVpHKTG {
  color: var(--ds-text-selected, #0c66e4);
}
.GPaBitB6ndYbkq {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  list-style-type: none;
  cursor: pointer;
}
.GPaBitB6ndYbkq li {
  list-style-type: none;
}
.GPaBitB6ndYbkq li {
  padding: 6px 12px;
  list-style-type: none;
}
.GPaBitB6ndYbkq li:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.GPaBitB6ndYbkq li:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
}
`, ""]);
// Exports
var _1 = `H6_i0WShUjYCHR`;
export { _1 as "nch-list" };
var _2 = `lzrY4EYP5_SBYj`;
export { _2 as "nch-list__item" };
var _3 = `R4JCamcPDlrWzL`;
export { _3 as "nch-list__cell" };
var _4 = `uGtyPvoqpvcvdA`;
export { _4 as "nch-list__cell-image" };
var _5 = `eQgJeMj8wdLrO7`;
export { _5 as "nch-list__cell-content" };
var _6 = `oxWwWrsQvWQ_eZ`;
export { _6 as "nch-list__cell--selected" };
var _7 = `oIwB6kV3H6azbz`;
export { _7 as "nch-list__cell-meta" };
var _8 = `UiFE4JadVpHKTG`;
export { _8 as "nch-list__cell-meta--selected" };
var _9 = `GPaBitB6ndYbkq`;
export { _9 as "nch-list--static" };
export default ___CSS_LOADER_EXPORT___;
